import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import ServicesPage from '@/pages/services/page';
import ProductsPage from '@/pages/products/page';
import AboutPage from '@/pages/about/page';
import ContactPage from '@/pages/contact/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/servicios', element: <ServicesPage /> },
  { path: '/productos', element: <ProductsPage /> },
  { path: '/nosotros', element: <AboutPage /> },
  { path: '/contacto', element: <ContactPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
